import o from"./tooltip";export{StyledTooltipTrigger,StyledTooltipArrow,StyledTooltipContent,StyledTooltip}from"./tooltip.styles";export default o;